
import Button from '../../../components/base/Button';

export default function PricingSection() {
  const pricingPlans = [
    {
      title: 'PNFストレッチ',
      plans: [
        { duration: '30分', price: '¥3,300', description: '肩甲骨はがし、股関節、肩回りなど気になる箇所を集中的に' },
        { duration: '60分', price: '¥5,500', description: '全身の疲労を緩和し、一人では伸ばしきれないところまで全身ストレッチ' }
      ]
    },
    {
      title: 'PNFボディメイクフェイシャルストレッチ',
      plans: [
        { duration: '30分', price: '¥3,300', description: '小顔・リフトアップ効果！肩こりや眼精疲労の方にお勧め' }
      ]
    },
    {
      title: 'パーソナルトレーニング',
      plans: [
        { duration: '30分', price: '¥3,300', description: 'マンツーマンで正しいフォームを指導、個別メニューをご提案' }
      ]
    },
    {
      title: 'パーソナルトレーニング＋ストレッチ',
      plans: [
        { duration: '60分', price: '¥6,600', description: '30分トレーニング後、30分ストレッチでカラダをスッキリ整える' }
      ]
    },
    {
      title: 'ボディもみほぐし',
      plans: [
        { duration: '15分', price: '¥1,600', description: '短時間でリフレッシュ、他のメニューとの組み合わせもおすすめ' },
        { duration: '30分', price: '¥3,300', description: 'しっかりとしたもみほぐしで疲労回復' }
      ]
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">料金表</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            複数メニューの組み合わせも可能。お得な回数券もご用意しております
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {pricingPlans.map((category, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">{category.title}</h3>
              
              <div className="space-y-4">
                {category.plans.map((plan, planIndex) => (
                  <div key={planIndex} className="bg-white rounded-lg p-6 shadow-sm">
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <span className="text-lg font-semibold text-gray-900">{plan.duration}</span>
                      </div>
                      <div className="text-right">
                        <span className="text-2xl font-bold text-teal-600">{plan.price}</span>
                      </div>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed">{plan.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-teal-600 text-xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">お得な回数券</h4>
              <p className="text-gray-600 text-sm">最大5,000円お得になる回数券をご用意</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-4">
                <i className="ri-building-line text-blue-600 text-xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">福利厚生対応</h4>
              <p className="text-gray-600 text-sm">会社の福利厚生としてもご利用いただけます</p>
            </div>
            
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                <i className="ri-graduation-cap-line text-green-600 text-xl"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2">学割あり</h4>
              <p className="text-gray-600 text-sm">学生様には特別割引をご用意しています</p>
            </div>
          </div>
        </div>
        
        <div className="text-center">
          <Button size="lg" onClick={scrollToContact}>
            <i className="ri-phone-line mr-2"></i>
            料金について詳しく相談する
          </Button>
        </div>
      </div>
    </section>
  );
}
